import { GetStatementLinesApiParameter, GetStatementsApiParameter } from "@bToC/Services/StatementService";
import { CustomActions } from "@bToC/Store/Reducers";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<GetStatementLinesApiParameter & UpdateSearchFieldsType, DispatchProp<CustomActions>>;

export const DispatchUpdateLineSearchFields: HandlerType = props => {
    props.dispatch({
        type: "CustomPages/Statements/UpdateLineSearchFields",
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateLineSearchFields];

const updateLineSearchFields = createHandlerChainRunnerOptionalParameter(chain, {}, "UpdateLineSearchFields");
export default updateLineSearchFields;
